import { EventEmitter, OnDestroy, Output } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';

import { StorageKeyEnum } from 'src/app/core/StorageKeyEnum';

@Component({
  selector: 'app-summary-container',
  templateUrl: './summary-container.component.html',
  styleUrls: ['./summary-container.component.scss']
})
export class SummaryContainerComponent implements OnInit,OnDestroy {
  summary: boolean;
  private destroy$ = new Subject<void>();
  @Output() showSummary: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor() { }

  ngOnInit(): void {
    if (sessionStorage.getItem(StorageKeyEnum.Summary)) {
      this.summary = JSON.parse(sessionStorage.getItem(StorageKeyEnum.Summary));
      this.showSummary.emit(this.summary);
    } else {
      this.manageSummary();
    }
  }

  manageSummary(): void {
    this.summary = !this.summary;
    this.showSummary.emit(this.summary);
    sessionStorage.setItem(StorageKeyEnum.Summary, this.summary.toString());
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}
